// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Brbx","type":"styles_type__1ykaA","choices":"styles_choices__EkrJp"};